import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import moment from "moment";
// components
import { debounce } from "../../common/commonFiles/debounce";
import Index from "../../common/Components/Index";
import { HeaderData, HeaderDataOrgAdmin } from "./Header";
import QuickFilter from "./QuickFilter";
import notifications from "../../common/Components/Notifications/Notification";
import ViewArtfom from "../artform/ViewArtfom";
import DeleteConfirm from "../../common/Components/DeleteConfirm";
// store
import { getUsers } from "../../Store/users/actions";
import { getTypes } from "../../Store/type/actions";
import { getArtforms } from "../../Store/artform/actions";
import { deleteCategory, getCategory } from "../../Store/category/actions";
import CategoryModal from "./CategoryModal";
import { isArray } from "lodash";
var offset: any = 0;
var limit: any = 10;
var totPages = 0;
var totCnt: any = 0;
var toVal: any = 0;
var fromVal: any = 0;
// selector options
var artformOptions: any = [];
var typeOptions: any = [];
var creatorOptions: any = [];
const Category = (props: any) => {
  const [loading, setLoading]: any = useState(false);
  const [openModal, setOpenModal]: any = useState(false);
  const [editData, setEditData]: any = useState("");
  const [deleteData, setDeleteData]: any = useState("");
  const [filters, setFilters]: any = useState({
    artform: "",
    type: "",
    category: "",
    creator: "",
  });
  const [filterDateValue, setFilterDateValue]: any = useState(null);
  const [sortName, setSortName]: any = useState({
    name: "",
    order: "",
  });
  const [warningModal, setWarningModal]: any = useState(false);
  const [openViewModal, setOpenViewModal]: any = useState(false);
  const [viewData, setViewData]: any = useState("");
  let auth: any = localStorage.getItem("authUser");
  let authUser: any = JSON.parse(auth) || "";
  let organizationId =
    authUser?.users?.role === "ORGANIZATION_MANAGER" ||
    authUser?.users?.role === "ORGANIZATION_ADMIN"
      ? authUser?.users?.organizationResponse?._id
      : "";
  const openViewModalPopUp = () => {
    setOpenViewModal(true);
  };
  const openModalPopUp = () => {
    setOpenModal(true);
  };
  const closeModal = () => {
    setOpenModal(false);
    setEditData("");
    setOpenViewModal(false);
    setViewData("");
  };
  const handlePageChange = (event: any, value: any) => {
    offset = (value - 1) * 1;
    getAllData({
      ...filters,
      offset,
      filterDateValue,
    });
  };
  useEffect(() => {
    getAllData();
  }, []);

  const getTypesData = (data?: any) => {
    props.getTypes(
      {
        offset: 0,
        limit: 10,
        artFormId: filters?.artform?.value || data?.artform,
        typeName: data?.value,
      },
      (res: any) => {
        typeOptions = [];
        res?.data?.docs.map((ele: any) => {
          typeOptions.push({
            label: ele?.name,
            value: ele?._id,
          });
        });
      }
    );
  };
  const getArtformData = (data?: any) => {
    props.getArtforms(
      {
        offset: 0,
        limit: 10,
        artformName: data?.value,
      },
      (res: any) => {
        artformOptions = [];
        res?.data?.docs.map((ele: any) => {
          artformOptions.push({
            label: ele?.name,
            value: ele?._id,
          });
        });
      }
    );
  };
  const getCreatorsData = (data?: any) => {
    props.getUsers(
      {
        offset: offset,
        limit: 10,
        organizationId,
        usersName: data?.value,
      },
      (res: any) => {
        creatorOptions = [];
        res?.data?.docs.map((ele: any) => {
          creatorOptions.push({
            label: ele?.name,
            value: ele?._id,
          });
        });
      }
    );
  };
  const getAllData = (filters?: any) => {
    let orderByAsc = sortName?.order === "asc" ? "1" : "";
    let orderByDesc = sortName?.order === "desc" ? "-1" : "";
    let dateValue = filters?.filterDateValue || filterDateValue;
    let startDate =
      dateValue?.length && moment(dateValue[0]).format("YYYY-MM-DD");
    let endDate =
      dateValue?.length && moment(dateValue[1]).format("YYYY-MM-DD");
    setLoading(true);
    props.getCategory(
      {
        offset: offset,
        limit: limit,
        categoryName: filters?.category,
        artformId: filters?.artform?.value,
        typeId: filters?.type?.value,
        categoryId: filters?.category?.value,
        startDate,
        endDate,
        sortBy: sortName?.name,
        orderBy: orderByAsc || orderByDesc,
        createdBy: filters?.creator?.value,
      },
      () => {
        setLoading(false);
      }
    );
    setEditData("");
  };
  var data: any = [];

  const deleteDataWithConfirm = (deleteData: any) => {
    props.deleteCategory(
      {
        categoryId: deleteData?._id,
      },
      (res: any) => {
        if (res.success) {
          notifications({
            title: "Success!",
            message: res?.message,
            type: "success",
          });
          getAllData();
        } else {
          notifications({
            title: "Error!",
            message: res?.message,
            type: "danger",
          });
        }
      }
    );
  };
  const getArtFormViewData = (id: any) => {
    props.getArtforms(
      {
        offset: 0,
        limit: 1,
        artFormId: id,
      },
      (res: any) => {
        artformOptions = [];
        setViewData(res?.data?.docs[0]);
      }
    );
  };
  if (props.categoryDetails !== undefined) {
    if (
      isArray(props?.categoryDetails?.data?.docs) &&
      props?.categoryDetails?.data?.docs?.length > 0
    ) {
      totCnt = props?.categoryDetails?.data?.length;
      totPages = Math.ceil(totCnt / 10);
      fromVal = totCnt !== 0 ? offset * 10 + 1 : fromVal;
      toVal =
        props?.categoryDetails?.data?.offset * 10 +
        props?.categoryDetails?.data?.docs?.length;
      props?.categoryDetails?.data?.docs.map((ele: any, i: any) => {
        data.push({
          category: ele?.name,
          type: ele?.type?.name,
          artForm: (
            <span
              onClick={() => {
                getArtFormViewData(ele?.artform?._id);
                openViewModalPopUp();
              }}
            >
              {ele?.artform?.name}
            </span>
          ),
          createdBy: ele?.createdBy?.role
            ? ele?.createdBy?.role?.replace("_", " ")
            : "NA",
          createdAt: ele?.createdAt
            ? moment(new Date(ele?.createdAt))
                .subtract(5, "hours")
                .subtract(30, "minutes")
                .format("YYYY-MM-DD LT")
            : "NA",
          actions: (
            <div className="d-flex align-items-center tableBtns">
              <span
                className="btns"
                onClick={() => {
                  setEditData(ele);
                  openModalPopUp();
                }}
              >
                Edit
              </span>
              <span className="actionLineHeight"></span>
              &nbsp;&nbsp;
              <span
                className="btns"
                onClick={() => {
                  setDeleteData(ele);
                  setWarningModal(true);
                }}
              >
                Delete
              </span>
            </div>
          ),
        });
      });
    } else {
      totCnt = 0;
      totPages = 0;
    }
  }
  const handleOnchangeFilter = (type: any) => {
    offset = 0;
    setFilters({
      ...filters,
      [type.name]: type?.value,
    });
  };
  const handleResetData = () => {
    setFilters({
      artform: "",
      type: "",
      category: "",
      weaveType: "",
      subCategory: "",
      creator: "",
    });
    setFilterDateValue(null);
    props.getCategory(
      {
        offset: offset,
        limit: limit,
      },
      () => {
        setLoading(false);
      }
    );
  };
  const handleChangeDate = (date: any) => {
    offset = 0;
    setFilterDateValue(date);
  };
  useEffect(() => {
    if (sortName?.name?.length > 0) {
      getAllData();
    }
  }, [sortName]);
  useEffect(() => {
    if (filters?.category?.length) {
      handleChangeDebounce({ ...filters, filterDateValue });
    } else if (
      filters?.artform?.value ||
      filters?.type?.value ||
      filters?.creator?.value
    ) {
      getAllData({
        ...filters,
        filterDateValue,
      });
    }
  }, [filters]);
  useEffect(() => {
    if (filterDateValue?.length > 0) {
      getAllData({ ...filters, filterDateValue });
    }
  }, [filterDateValue]);
  const handleChangeDebounce = React.useCallback(
    debounce((data: any) => {
      getAllData(data);
    }, 1000),
    []
  );
  const handleSort = (data: any) => {
    if (data?.name === "weaveType") {
      setSortName({
        name: "weavetype",
        order: data?.sort,
      });
    } else if (data?.name === "artForm") {
      setSortName({
        name: "artform",
        order: data?.sort,
      });
    } else if (data?.name === "type") {
      setSortName({
        name: "type",
        order: data?.sort,
      });
    } else if (data?.name === "category") {
      setSortName({
        name: "category",
        order: data?.sort,
      });
    } else if (data?.name === "subCategory") {
      setSortName({
        name: "subcategory",
        order: data?.sort,
      });
    } else if (data?.name === "createdAt") {
      setSortName({
        name: "createdAt",
        order: data?.sort,
      });
    } else if (data?.name === "createdBy") {
      setSortName({
        name: "createdBy",
        order: data?.sort,
      });
    }
  };
  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      getAllData();
    }
  };
  const autoFocus = (data: any) => {
    if (data?.name === "artform") {
      getArtformData();
    } else if (data?.name === "creator") {
      getCreatorsData();
    } else if (data?.name === "type") {
      getTypesData();
    }
  };
  const handleChangeDebounce1 = React.useCallback(
    debounce((data: any) => {
      if (data?.name === "artform") {
        getArtformData(data);
      }
      if (data?.name === "type") {
        getTypesData(data);
      }
      if (data?.name === "creator") {
        getCreatorsData(data);
      }
    }, 1000),
    []
  );
  const handleOnInputChange = (type: any) => {
    if (type?.name === "artform") {
      if (type?.value?.length >= 2) {
        handleChangeDebounce1({
          name: type?.name,
          value: type?.value,
        });
      }
      if (
        type?.value.length === 0 &&
        !filters?.artform?.value &&
        !filters?.type?.value &&
        !filters?.category?.value &&
        !filters?.subCategory?.value &&
        !filters?.weaveType?.value
      ) {
        handleChangeDebounce1({
          name: type?.name,
          value: type?.value,
        });
      }
    }
    if (type?.name === "type") {
      if (type?.value?.length >= 2) {
        handleChangeDebounce1({
          name: type?.name,
          value: type?.value,
          artform: filters?.artform?.value,
        });
      } else if (
        type?.value.length === 0 &&
        filters?.artform?.value &&
        !filters?.type?.value &&
        !filters?.category?.value &&
        !filters?.subCategory?.value &&
        !filters?.weaveType?.value
      ) {
        handleChangeDebounce1({
          name: type?.name,
          value: type?.value,
          artform: filters?.artform?.value,
        });
      }
    }

    if (type?.name === "creator") {
      if (type?.value?.length >= 2) {
        handleChangeDebounce1({
          name: type?.name,
          value: type?.value,
        });
      }
      if (type?.value.length === 0) {
        handleChangeDebounce1({
          name: type?.name,
          value: type?.value,
        });
      }
    }
  };
  const warningToggle = () => {
    setWarningModal(false);
  };
  return (
    <>
      {openViewModal && (
        <ViewArtfom
          {...props}
          closeModal={closeModal}
          openModal={openViewModal}
          viewData={viewData}
        />
      )}
      <DeleteConfirm
        {...props}
        warningModal={warningModal}
        warningToggle={warningToggle}
        deleteDataWithConfirm={deleteDataWithConfirm}
        deleteData={deleteData}
        getAllData={getAllData}
        name={"Category"}
      />
      <CategoryModal
        {...props}
        openModal={openModal}
        closeModal={closeModal}
        editData={editData}
        getAllData={getAllData}
      />
      <QuickFilter
        {...props}
        openModalPopUp={openModalPopUp}
        artformOptions={artformOptions}
        handleOnchangeFilter={handleOnchangeFilter}
        typeOptions={typeOptions}
        creatorOptions={creatorOptions}
        filters={filters}
        handleChangeDate={handleChangeDate}
        filterDateValue={filterDateValue}
        handleResetData={handleResetData}
        handleKeyDown={handleKeyDown}
        getAllData={getAllData}
        autoFocus={autoFocus}
        handleOnInputChange={handleOnInputChange}
      />
      <Index
        {...props}
        data={data}
        headerData={
          authUser?.users?.role === "ORGANIZATION_MANAGER" ||
          authUser?.users?.role === "ORGANIZATION_ADMIN"
            ? HeaderDataOrgAdmin
            : HeaderData
        }
        limit={limit}
        handleChange={handlePageChange}
        offset={offset}
        totPages={totPages}
        loading={loading}
        handleSort={handleSort}
        fromVal={fromVal}
        toVal={toVal}
        totCnt={totCnt}
      />
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    ...state,
    categoryDetails: state?.categoryReducer?.getCategoryDetails,
  };
};
export default connect(mapStateToProps, {
  deleteCategory,
  getCategory,
  getArtforms,
  getTypes,
  getUsers,
})(Category);
